import { Check } from '@/components/icons'
import { cn } from '@/lib/cn'
import { AVATAR_COLORS, avatarColorVar, type AvatarColorName } from '@/lib/avatarColors'

/**
 * Fixed palette swatch picker for avatar identities.
 */
export function AvatarColorPicker({
  value,
  onChange,
  disabled,
}: {
  value: AvatarColorName
  onChange: (color: AvatarColorName) => void
  disabled?: boolean
}) {
  return (
    <div role="radiogroup" aria-label="Avatar colour" className="flex flex-wrap gap-2">
      {AVATAR_COLORS.map((name) => {
        const selected = name === value
        return (
          <button
            key={name}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={name}
            disabled={disabled}
            onClick={() => { onChange(name) }}
            style={{ backgroundColor: avatarColorVar(name) }}
            className={cn(
              'flex h-7 w-7 items-center justify-center rounded-full',
              'transition-transform duration-150',
              'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
              'disabled:cursor-not-allowed disabled:opacity-40',
              selected && 'ring-2 ring-offset-2 ring-[var(--color-text)]',
            )}
          >
            {selected && <Check size={14} strokeWidth={2.5} className="text-white" aria-hidden />}
          </button>
        )
      })}
    </div>
  )
}
